import auth0 from 'auth0-js';

export default new auth0.WebAuth({
  domain: process.env.AUTH0_DOMAIN,
  clientID: process.env.AUTH0_CLIENTID,
  redirectUri: process.env.AUTH0_REDIRECT_URI,
  audience: process.env.AUTH0_AUDIENCE,
  responseType: 'code',
  // more settings are available but it should be enough for us (email and potential photo)
  // the other infos (first and last names are coming from the meta data of the user)
  scope: 'openid email',
});
